export const formatTime = (date) => {
    try {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const messageDate = new Date(date);
        const messageDay = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
        if (messageDay.getTime() === today.getTime()) {
            return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        if (messageDay.getTime() === yesterday.getTime()) {
            return 'Yesterday';
        }
        return messageDate.toLocaleDateString([], { month: 'short', day: 'numeric' });
    } catch (e) {
        console.log("format time error chat util ", e);
    }
};

export const formatRelativeTime = (date) => {
    try {
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
        if (diffInSeconds < 60) {
            return 'Just now';
        }
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `${diffInMinutes} min${diffInMinutes > 1 ? 's' : ''} ago`;
        }
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
        }
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) {
            return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
        }
        return formatTime(date);
    }
    catch (e) {
        console.log("format Relative Time error chat Util ", e);
    }
};
export const truncateText = (text, maxLength) => {
    try {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + '...';
    } catch (e) {
        console.log("truncateText chatUtils error ", e)
    }
};
export const getInitials = (name, fallback = '??') => {
    try {
        if (!name || typeof name !== 'string' || name.trim().length === 0) {
            return fallback;
        }
        const cleanedName = name
            .replace(/[-_\.]+/g, ' ') // Replace separators with a single space
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space for camelCase: saiSarath -> sai Sarath
            .replace(/[^a-zA-Z0-9\s]/g, '') // Remove non-alphanumeric characters (excluding space)
            .trim();
        const parts = cleanedName.split(/\s+/).filter(part => part.length > 0); // Split by one or more spaces and remove empty parts
        let initials = '';
        if (parts.length === 0) {
            // If no valid parts found after cleaning (e.g., name was " _.- ")
            return fallback;
        } else if (parts.length === 1) {
            // If only one part (e.g., "Sai", "S", "Sathish")
            const singlePart = parts[0];
            initials = singlePart.substring(0, 2); // Take the first two characters
        } else {
            // If multiple parts (e.g., ["sai", "Sarath"], ["Sai", "Sarath", "Kumar"])
            initials = parts[0].charAt(0) + parts[1].charAt(0); // Take the first char of the first two parts
        }

        // 5. Final formatting: Uppercase and ensure it's not empty
        const finalInitials = initials.toUpperCase();

        return finalInitials.length > 0 ? finalInitials : fallback;
    } catch (error) {
        console.error('Error getting initials:', error);
        return name
            ?.split(' ')
            .map(part => part.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2) || fallback;
    }
};


export const getUserId = () => {
    return localStorage.getItem('userId') || '';
}

export const getUserName = () => {
    return localStorage.getItem('userName') || '';
}

export const getCustomer = () => {
    return localStorage.getItem('customer') || '';
}

export const getAgentId = () => {
    return localStorage.getItem('agentId') || '';
}

export const getAgentUniqId = () => {
    return localStorage.getItem('agentUniqId') || '';
} 